import { bootstrapApp } from '../lib/actions';

const baseUri = process.env.BASE_URI;

const DataDependencies = [
  {
    path: baseUri,
    loadData: (args, callback) => {
      callback();
    },
    routes: [
      {
        path: `${baseUri}press`,
        loadData: ({ store, req }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: 'press-page',
              callback,
              query: req.query,
            })
          );
        },
      },
      {
        path: `${baseUri}specialists`,
        loadData: ({ store }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: 'specialists-page',
              callback,
            })
          );
        },
      },
      {
        path: `${baseUri}news`,
        loadData: ({ store }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: 'headlines',
              callback,
            })
          );
        },
      },
      {
        path: `${baseUri}careers/:slug`,
        loadData: ({ store, match }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: 'department-page',
              callback,
              params: match.params,
            })
          );
        },
      },
      {
        path: `${baseUri}`,
        loadData: ({ store, req }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: '/',
              callback,
              req,
            })
          );
        },
      },
    ],
  },
];

export default DataDependencies;
